<div [innerHTML]="blog.htmlString" dir="rtl" class="my-5">

</div>